import request from '@/utils/request.js'
import axios from "axios";

/** 获取加油站列表信息 */
export function searchGasStationList ({ name, number, status }) {
  return request({
    url: '/oilstore/index',
    method: 'get',
    params: {
      name, number, status
    }
  })
}

/** 获取加油站下拉列表 */
export function searchGasStationCodeList ({ page, limit }) {
  return request({
    url: '/oilstore/option',
    method: 'get',
    params: {
      page,
      limit
    }
  })
}

/** 新增油站 */
export function addGasStation ({ name, number, status, mobile, store_address, business_hours }) {
  return request({
    url: '/oilstore/add',
    method: 'post',
    data: {
      name, number, status, mobile, store_address, business_hours
    }
  })
}

/** 修改油站 */
export function editGasStation ({ id, name, number, status, mobile, store_address, business_hours }) {
  return request({
    url: '/oilstore/edit',
    method: 'post',
    data: {
      id, name, number, status, mobile, store_address, business_hours
    }
  })
}

/** 删除油站 */
export function deleteGasStation (ids) {
  return request({
    url: '/oilstore/del',
    method: 'get',
    params: {
      ids
    }
  })
}
/** 腾讯地图地址逆解析 */
export function getLocationInfo(params) {
  return request({
    url: '/store/getLocation',
    method: 'get',
    params: {
      lat: params.lat,
      lng: params.lng
    }
  })
}




